/**
 * Лінивий вхід банера «Оновіть браузер» (UX-52): таблиця версій і сам банер (`BrowserUpdateBanner`)
 * не входять у перший екран (бюджет). Після межі першого екрана (perf/first-screen.ts: перший
 * намальований маршрут, кадр і простій; простій після `load` настає ще до даних стартового екрана,
 * і чанк був би запитом першого екрана) шлюз бере лише таблицю
 * (`support/browser.ts`; вона в одному чанку з `web-vitals`, який RUM просить і так — окремого
 * запиту немає) і вантажить чанк банера, тільки коли браузер справді старий і нагадування не
 * відкладено: сучасному браузеру зайвого запиту й спільних чанків маршрутів це не коштує. Банер, що
 * з'явився вже після кадру, — найнижчий за пріоритетом і потрібен рідкісним старим браузерам.
 * Збій `import()` просто не показує банер.
 */
import { type ComponentType, useEffect, useState } from 'react';
import { afterFirstScreen } from '../perf/first-screen.ts';

export function BrowserUpdateGate() {
  const [Banner, setBanner] = useState<ComponentType | null>(null);
  useEffect(() => {
    let live = true;
    const load = () => {
      import('../support/browser.ts')
        .then((b) =>
          b.outdatedBrowser(navigator.userAgent) && b.nudgeDue(Date.now())
            ? import('./BrowserUpdateBanner.tsx')
            : null,
        )
        .then(
          (m) => live && m && setBanner(() => m.default),
          () => undefined,
        );
    };
    const cancel = afterFirstScreen(load);
    return () => {
      live = false;
      cancel();
    };
  }, []);
  return Banner ? <Banner /> : null;
}
